<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tipoloteo">
    <fieldset id="agregar_tipoloteo" class="">
        <div class="step_section">
            <div class="row" id="row">
                <form [formGroup]="form">
                    <div class="col-md-12" id="content">
                        <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                            <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            <span id="tp_dir_message"></span>
                        </div>
                        <div class="form-horizontal titulo">
                            <div class="form-group" align="left">
                                <div class="col-sm-2">
                                    <label for="tipoaprob" *ngIf="number != '3.8'">Tipo de Solicitud:</label>
                                    <label for="tipoaprob" *ngIf="number == '3.8' || number == '3.10' || number == '3.6'">Tipo de Proyecto:</label>
                                </div>
                                <div class="col-sm-10" class="inline" style="font-size: 13px">
                                    <div class="col-md-10">
                                        <mat-checkbox formControlName="mod1" name="mod1" value="SI" (change)="add_tipo_mod()">LOTEO</mat-checkbox>
                                    </div>
                                    <div class="col-md-2"></div>
                                    <div class="col-md-10">
                                        <mat-checkbox formControlName="mod2" name="mod2" value="SI" (change)="add_tipo_mod()">URBANIZACI&Oacute;N</mat-checkbox>
                                    </div>
                                    <div class="col-md-2"></div>
                                    <div class="col-md-10" *ngIf="number != '3.10'">
                                        <mat-checkbox formControlName="mod3" name="mod3" value="SI" (change)="add_tipo_mod()">LOTEO CON CONSTRUCCI&Oacute;N <br>SIMULTANEA</mat-checkbox>
                                    </div>
                                    <div class="col-md-2" *ngIf="number != '3.10'"></div>
                                    <div class="col-md-10" *ngIf="number != '3.10'">
                                        <mat-checkbox formControlName="mod4" name="mod4" value="SI" (change)="add_tipo_mod()">LOTEO DFL 2 CON CONSTRUCCION <br>SIMULTANEA</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </form>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>